// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Assistent',
  },
  close: {
    amigo: 'Amigo schließen',
    assistant: 'Assistent schließen',
  },
  brand: 'Marke',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Chats',
  new_chat: 'Neuer Chat',
  back: 'Zurück zum Chat',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Neue Antworten in einem anderen Chat',
  news_elsewhere_other: 'Neue Antworten in {{count}} anderen Chats',
};
